import { HighContrastMode } from '../services/models/accesibility.model';
import { Action, NgxsOnInit, Selector, State, StateContext } from '@ngxs/store';
import { inject, Injectable } from '@angular/core';
import { EnableHighContrast, SetHighContrastMode } from './accessibility.actions';
import { patch } from '@ngxs/store/operators';
import { AccessibilityService } from '../services/accessibility.service';

type AccessibilityStateModel = {
  highContrastMode: HighContrastMode;
  highContrastModeEnabled: boolean;
}

const initialState: AccessibilityStateModel = {
  highContrastModeEnabled: false,
  highContrastMode: HighContrastMode.DISABLED,
}

@State<AccessibilityStateModel>({
  name: 'accessibility',
  defaults: initialState,
})
@Injectable()
export class AccessibilityState implements NgxsOnInit {
  private readonly accessibilityService = inject(AccessibilityService);
  private readonly storageKey = 'ACCESSIBILITY_STATE';

  ngxsOnInit(context: StateContext<AccessibilityStateModel>) {
    const localData = localStorage.getItem(this.storageKey);

    if (localData) {
      const data = JSON.parse(localData);
      context.dispatch(new EnableHighContrast(data.highContrastModeEnabled));
      context.dispatch(new SetHighContrastMode(data.highContrastMode));
    }
  }

  @Selector()
  static highContrastMode(state: AccessibilityStateModel): HighContrastMode {
    return state.highContrastMode;
  }

  @Selector()
  static highContrastEnabled(state: AccessibilityStateModel): boolean {
    return state.highContrastModeEnabled;
  }

  @Action(EnableHighContrast)
  enableHighContrast(context: StateContext<AccessibilityStateModel>, { enable }: EnableHighContrast) {
    context.setState(patch<AccessibilityStateModel>({
      highContrastModeEnabled: enable,
    }));
  }

  @Action(SetHighContrastMode)
  setHighContrastMode(context: StateContext<AccessibilityStateModel>, { mode }: SetHighContrastMode) {

    if (!context.getState().highContrastModeEnabled) {
       return;
    }

    this.accessibilityService.applyHighContrastMode(mode);

    context.setState(patch<AccessibilityStateModel>({
      highContrastMode: mode,
    }));

    const data = JSON.stringify({
      highContrastModeEnabled: context.getState().highContrastModeEnabled,
      highContrastMode: mode,
    });

    localStorage.setItem(this.storageKey, data);
  }
}
